import { jsx as _jsx } from "react/jsx-runtime";
export function Divider({ vertical, dotted, color = 'var(--border)', style, className, }) {
    if (dotted) {
        return (_jsx("div", { className: className, style: vertical
                ? { width: 0, alignSelf: 'stretch', borderInlineStart: `1px dotted ${color}`, ...style }
                : { height: 0, borderTop: `1px dotted ${color}`, width: '100%', ...style } }));
    }
    return (_jsx("div", { className: className, style: vertical
            ? { width: 1, alignSelf: 'stretch', background: color, ...style }
            : { height: 1, background: color, width: '100%', ...style } }));
}
//# sourceMappingURL=Divider.js.map